<template>
  <v-row class="px-4 pt-3 pb-4 details-policy__card">
    <v-col cols="12">
      <p class="primary--text font-weight-bold">
        OUTRAS INFORMAÇÕES
      </p>
    </v-col>
    <v-col cols="12" class="details-policy__item">
      <v-row class="pa-4">
        <v-col cols="12">
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-policy__text-height"
          >
            N° Interno:
            <label class="details-policy__value primary--text">
              {{ item.numero_controle_interno }}
            </label>
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-policy__text-height"
          >
            N° Processo:
            <label class="details-policy__value primary--text">
              {{ item.processo && item.processo.numero_processo }}
            </label>
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-policy__text-height"
          >
            Segurado/Reclamante:
            <label class="details-policy__value primary--text">
              {{ item.segurado && item.segurado.nome }}
            </label>
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-policy__text-height"
          >
            Tribunal:
            <label
              class="details-policy__value primary--text"
              v-if="withoutURL"
            >
              {{ nameCourt }}
            </label>
            <a
              class="details-policy__value secondary--text"
              :href="item.processo.tribunal.site"
              target="_blank"
              v-else
            >
              {{ nameCourt }}
            </a>
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-policy__text-height"
          >
            Vara:
            <label class="details-policy__value primary--text">
              {{ nameRegionCourt }}
            </label>
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-policy__text-height"
          >
            Seguradora:
            <label class="details-policy__value primary--text">
              {{ item.seguradora && item.seguradora.nome }}
            </label>
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-policy__text-height"
          >
            Submodalidade:
            <label class="details-policy__value primary--text">
              {{ item.submodalidade && item.submodalidade.nome }}
            </label>
          </p>
          <p
            class="caption darkBluishGray--text mb-0 font-weight-medium details-policy__text-height"
          >
            Origem:
            <label class="details-policy__value primary--text">
              {{ nameOriginPolicy }}
            </label>
          </p>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
export default {
  computed: {
    nameRegionCourt() {
      return (
        this.item.processo?.unidade?.nome || this.item.processo?.nome_unidade || "NÃO SE APLICA"
      );
    },
    nameCourt() {
      return (
        this.item.processo?.tribunal?.nome || this.item.processo?.nome_tribunal
      );
    },
    withoutURL() {
      return (
        !this.item.processo?.tribunal?.site ||
        this.item.processo?.tribunal?.site == ""
      );
    },
    nameOriginPolicy() {
      return this.item.origem_cadastro?.nome || "CADASTRO LSP";
    }
  },
  props: {
    item: {
      type: Object
    }
  }
};
</script>
